export default "__VITE_PUBLIC_ASSET__a120fd0e__"